// modules/land-for-sale/elements/PlanLotsContainer.js
import React        from 'react';
const sources = require('../../config.json');

class PlanLotsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {active: false};

        if(sources.activestatus.indexOf(this.props.element.status) !== -1) {
            this.showHoverEvent = this.showHoverEvent.bind(this);
            this.hideHoverEvent = this.hideHoverEvent.bind(this);

            this.props.messenger.subscribe("a_" + this.props.element.id, this.showHoverEvent);
            this.props.messenger.subscribe("c_" + this.props.element.id, this.hideHoverEvent);
        }
    }

	componentWillUnmount() {
        if(sources.activestatus.indexOf(this.props.element.status) !== -1) {
            this.props.messenger.remove("a_" + this.props.element.id);
            this.props.messenger.remove("c_" + this.props.element.id);
        }
	}

    showHoverEvent() {
        this.setState({active:true});
    }

    hideHoverEvent() {
        this.setState({active:false});
    }



    render() {
        let divclasses = "landforsale-lot";
        if (this.state.active) {
            divclasses += " active";
        }
        switch(this.props.element.status) {
            case 2:
                divclasses += " sold";
                break;
            case 3:
                divclasses += " hold";
                break;
            case 4:
                divclasses += " deposit";
                break;
            default:
                divclasses += " available";
        }
        return(
            <div className="landforsale-map_lot_hover">
                <svg width={this.props.width} height={this.props.height}>
                    <polygon points={this.props.element.coords} className={divclasses} />
                </svg>
            </div>
        )
    }
}
export default PlanLotsContainer;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanLotOutline.js
 **/